import { Mapper } from '@Features/utils/prepareSearchCriterias';
import { SearchItemOperator } from '@Types/api/common/filters';
import { TypeDict } from '@Types/index';

import { FilterForm } from './types';
import { userCodes } from '../isNewUser.enum';
import { requiredRoleOptions } from '../fieldsOptions';

export const initialValuesFilterForm: FilterForm = {
  itemType: null,
  statuses: [],
  simCardCreditLimit: [],
  contactNumber: '',
  emailId: '',
  emailSignature: '',
  accessory: '',
  userInformation: [],
  module: '',
  accountsModule: '',
  organization: '',
  project: '',
  requiredRoles: [],
};

export const filterTypes: Record<
  keyof typeof initialValuesFilterForm,
  SearchItemOperator
> = {
  itemType: 'eq',
  statuses: 'in',
  simCardCreditLimit: 'in',
  contactNumber: 'like',
  emailId: 'like',
  emailSignature: 'like',
  accessory: 'like',
  userInformation: 'in',
  module: 'like',
  accountsModule: 'like',
  organization: 'eq',
  project: 'like',
  requiredRoles: 'in',
};

export const getFiltersMapper =
  (
    simCapValues: TypeDict[],
    accessories: TypeDict[],
    statuses: TypeDict[]
  ): Mapper =>
  (key, value) => {
    if (key === 'itemType') {
      return ['reqItemId', Number(value)];
    }

    if (key === 'simCardCreditLimit') {
      const resultValue = (value as string[]).map(
        (item) =>
          simCapValues.find((simCapValue) => simCapValue.codeDesc === item)!
            .codeNum
      );
      return ['reqCapValue', resultValue];
    }

    if (key === 'contactNumber') {
      return ['personalMobile', value];
    }

    if (key === 'emailId') {
      return ['userName', value];
    }

    if (key === 'emailSignature') {
      return ['accessories', value];
    }

    if (key === 'accessory') {
      const accessoryLabel =
        accessories.find((item) => item.codeNum === Number(value))?.codeDesc ||
        '';
      return ['accessories', accessoryLabel];
    }

    if (key === 'userInformation') {
      const resultValue = (value as string[]).map((item) => userCodes[item]);
      return ['isNewUser', resultValue];
    }

    if (key === 'module') {
      return ['module', value];
    }

    if (key === 'accountsModule') {
      return ['acctModules', value];
    }

    if (key === 'organization') {
      return ['organization', value];
    }

    if (key === 'project') {
      return ['project', value];
    }

    if (key === 'requiredRoles') {
      const resultValue = (value as string[]).map(
        (item) => requiredRoleOptions.find((role) => role.label === item)!.value
      );
      return ['role', resultValue];
    }

    const statusResultValue = (value as string[]).map(
      (item) => statuses.find((status) => status.codeDesc === item)!.codeNum
    );
    return ['statusId', statusResultValue];
  };
